// Sunsari Restaurant Contact Information

export const restaurantInfo = {
  name: "Sunsari Restaurant",
  address: {
    street: "Hietasaarenkatu 18",
    postalCode: "65100",
    city: "Vaasa",
    country: "Finland",
    fullAddress: "Hietasaarenkatu 18, 65100 Vaasa, Finland"
  },
  contact: {
    phone: "+358403779200",
    email: "ravintolasunsari@gmail.com",
    reservationEmail: "ravintolasunsari@gmail.com"
  },
  parking: {
    available: true,
    type: "Street parking and nearby parking areas",
    details: "Free street parking available on Hietasaarenkatu. Public parking lots within 100m walking distance.",
    tips: "Plenty of parking spaces in the surrounding area, especially in the evenings and weekends."
  },
  openingHours: {
    monday: { open: "11:00", close: "15:00", display: "11:00 - 15:00" },
    tuesday: { open: "11:00", close: "21:00", display: "11:00 - 21:00" },
    wednesday: { open: "11:00", close: "21:00", display: "11:00 - 21:00" },
    thursday: { open: "11:00", close: "21:00", display: "11:00 - 21:00" },
    friday: { open: "11:00", close: "22:00", display: "11:00 - 22:00" },
    saturday: { open: "12:00", close: "22:00", display: "12:00 - 22:00" },
    sunday: { open: "12:00", close: "20:00", display: "12:00 - 20:00" }
  },
  specialties: [
    "Authentic Nepalese Cuisine",
    "Nepalese & Indian Flavours", 
    "Daily Lunch Menu",
    "Tandoori Specialties",
    "Sizzling Hot Plates",
    "Fresh Salad Bar (25+ varieties)",
    "Vegan & Vegetarian Options"
  ],
  description: "Experience authentic Nepalese and Indian flavours at Sunsari Restaurant in Vaasa. We offer fresh daily lunch menus, traditional tandoori preparations, and a selection of over 50 dishes from our à la carte menu."
};

// Helper function to get current opening status
export const getCurrentOpeningStatus = () => {
  const now = new Date();
  const currentDay = now.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
  const currentTime = now.toLocaleTimeString('fi-FI', { hour: '2-digit', minute: '2-digit', hour12: false });
  
  const todayHours = restaurantInfo.openingHours[currentDay];
  if (!todayHours) return { isOpen: false, message: "Closed today" };
  
  const openTime = todayHours.open;
  const closeTime = todayHours.close;
  
  if (currentTime >= openTime && currentTime <= closeTime) {
    return { 
      isOpen: true, 
      message: `Open until ${closeTime}`,
      nextChange: `Closes at ${closeTime}`
    };
  } else if (currentTime < openTime) {
    return { 
      isOpen: false, 
      message: `Opens at ${openTime}`,
      nextChange: `Opens at ${openTime}`
    };
  } else {
    return { 
      isOpen: false, 
      message: "Closed",
      nextChange: "See opening hours"
    };
  }
};

// Helper function to get today's hours
export const getTodayHours = () => {
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
  const todayHours = restaurantInfo.openingHours[today];
  return todayHours ? todayHours.display : "Closed";
};